import { render } from "./GdprEraseAction.vue?vue&type=template&id=0b6dfb16&scoped=true"
import script from "./GdprEraseAction.vue?vue&type=script&lang=ts"
export * from "./GdprEraseAction.vue?vue&type=script&lang=ts"

import "./GdprEraseAction.vue?vue&type=style&index=0&id=0b6dfb16&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0b6dfb16"

export default script